import React from "react"
import { Switch } from "react-router-dom"

import UnauthenticatedRoute from "../../components/UnauthenticatedRoute"
// import ConfirmEmailView from "./ConfirmEmail"
import ResetPasswordView from "./ResetPassword"
import SignInView from "./SignIn"

const base = "/signin"

export default function SignIn() {
  return (
    <Switch>
      <UnauthenticatedRoute exact path={`${base}`}>
        <SignInView />
      </UnauthenticatedRoute>
      {/* <UnauthenticatedRoute exact path={`${base}/confirm`}>
        <ConfirmEmailView />
      </UnauthenticatedRoute> */}
      <UnauthenticatedRoute exact path={`${base}/reset`}>
        <ResetPasswordView />
      </UnauthenticatedRoute>
    </Switch>
  )
}
